import {USE_DRAFT_CONTENT} from '~/lib/const';

export default {
  apiVersion: import.meta.env.PUBLIC_SANITY_API_VERSION,
  dataset: import.meta.env.PUBLIC_SANITY_DATASET,
  projectId: import.meta.env.PUBLIC_SANITY_PROJECT_ID,
  // Don't use CDN if we want to show draft contents
  useCdn:
    !USE_DRAFT_CONTENT || import.meta.env.PUBLIC_SANITY_USE_CDN === 'true',
};
